export enum BusinessAccidentInsuranceCoverage {
  DAILY_ALLOWANCE_WORK_ACCIDENT = 'DAILY_ALLOWANCE_WORK_ACCIDENT',
  DAILY_ALLOWANCE_NON_WORK_ACCIDENT = 'DAILY_ALLOWANCE_NON_WORK_ACCIDENT',
  GENERAL_WARD_HEALTHCARE_SERVICES = 'GENERAL_WARD_HEALTHCARE_SERVICES',
  PRIVATE_DIVISION_HEALTHCARE_SERVICES = 'PRIVATE_DIVISION_HEALTHCARE_SERVICES',
  DISABILITY_PENSION = 'DISABILITY_PENSION',
}

export const BUSINESS_ACCIDENT_INSURANCE_COVERAGE_VALUES = Object.values(
  BusinessAccidentInsuranceCoverage
);

export const getBusinessAccidentInsuranceCoverageLabel = (
  coverage: BusinessAccidentInsuranceCoverage
) => {
  switch (coverage) {
    case BusinessAccidentInsuranceCoverage.DAILY_ALLOWANCE_WORK_ACCIDENT:
      return $localize`Indemnité journalière accident professionnel`;
    case BusinessAccidentInsuranceCoverage.DAILY_ALLOWANCE_NON_WORK_ACCIDENT:
      return $localize`Indemnité journalière accident non professionnel`;
    case BusinessAccidentInsuranceCoverage.GENERAL_WARD_HEALTHCARE_SERVICES:
      return $localize`Prestations de soins division commune`;
    case BusinessAccidentInsuranceCoverage.PRIVATE_DIVISION_HEALTHCARE_SERVICES:
      return $localize`Prestations de soins division privée`;
    case BusinessAccidentInsuranceCoverage.DISABILITY_PENSION:
      return $localize`Rente d'invalidité`;
    default:
      return '';
  }
};
